export default theme => ({
  avatar: {
    // width: '100%'
  }
});